import { Injectable } from '@angular/core';

import { MediaState, mediaInitialState } from '@frontend/sports/grid/media/feature/state';

import { StateLoader, StateSaver } from '../store-persist/state-storage.model';

export interface IMediaStateStorage {
    isLocationAllowsExpand: boolean;
    restoreExpandState: boolean;
}

export interface IMediaSavedState {
    media: IMediaStateStorage;
}

export function isMediaSavedState(savedState: object | undefined): savedState is IMediaSavedState {
    return !!savedState && 'media' in savedState;
}

@Injectable({
    providedIn: 'root',
})
export class MediaStateSaver implements StateSaver<MediaState, IMediaStateStorage> {
    save(state: MediaState): IMediaStateStorage {
        return {
            isLocationAllowsExpand: state.mediaExpandState.isLocationAllowsExpand,
            restoreExpandState: state.mediaExpandState.restoreExpandState,
        };
    }
}

@Injectable({
    providedIn: 'root',
})
export class MediaStateLoader implements StateLoader<IMediaStateStorage, MediaState> {
    load(state: IMediaStateStorage | undefined): MediaState {
        if (!state) {
            return { ...mediaInitialState };
        }

        return {
            ...mediaInitialState,
            mediaExpandState: {
                ...mediaInitialState.mediaExpandState,
                ...state,
            },
        };
    }
}
